import { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

const useClientes = () => {
  const [clientes, setClientes] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchClientes();
  }, []);

  const fetchClientes = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(API_ENDPOINTS.interna.SelectAllDataClient);
      if (!res.ok) throw new Error("Error al obtener datos del servidor");
      const data = await res.json();
      setClientes(data);
    } catch (err) {
      console.error("Error al cargar clientes:", err);
      setError("No se pudieron cargar los clientes.");
    } finally {
      setLoading(false);
    }
  };

  const filtrarClientes = () => {
    const q = busqueda.toLowerCase();
    return clientes.filter(
      (cliente) => cliente.nombre.toLowerCase().includes(q) || cliente.codigo.toLowerCase().includes(q) || cliente.username?.toLowerCase().includes(q) || (cliente.estado === 1 ? "activo" : "inactivo").includes(q)
    );
  };

  return {
    clientes,
    busqueda,
    setBusqueda,
    loading,
    error,
    filtrarClientes,
    fetchClientes, // ✅ nombre esperado por tu componente
  };
};

export default useClientes;
